/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

export class ReportContextInfo {
  // To identify discard scenario
  isDiscard = false;
  // List of contexts for which report opened
  contextItemList = [];
  // Previous context's requested procedure ID for response handling
  previousRequestedProcId = '';
  // Active context's accession number specifically for cancel report failure on tab close. In this case context
  // gets removed from context list before sending cancel report request. So getCurrentAccession() and
  // getPreviousAccession() returns ''. But activeContext still holds accession number of the active tab
  // even if it is closed because its value doesn't reset from removeContext() function. So activeContext is
  // used to display the accession number in cancel failure error message.
  activeContext = '';
  // Current context's siteName
  siteName = '';
  // Current context's index
  currentIndex = -1;
  // Holds the study click time
  reportLaunchTime = 0;
  // Holds the DxHub context
  dxHubContext = '';
  // Holds the report context
  reportContext = '';
}
